<template>
    <div>
        <input :autofocus="focused" :style="styled" type="search" id="table-search" @input="updateSearch($event.target.value)" placeholder="buscar..." ref="searchInput">
    </div>
</template>

<script>
export default {
    name: 'AppSearch',
    props: {
        visibility: {
            type: Boolean,
            default: () => false
        },
        focused: {
            type: Boolean,
            default: () => false
        },
        styled: {
            type: Object,
            default: () => ({
                width: '250px',
            })
        }
    },
    mounted() {
        if (this.focused) {
            this.$nextTick(() => {
                this.$refs.searchInput.focus();
            });
        }
    },
    methods: {
        updateSearch(text) {
            this.$emit("search", text);
        }
    }
}
</script>

<style scoped>

    #table-search {
        height: 30px;
        width: 250px;
        border-radius: 8px;
        background-color: var(--fundoApp);
        color: var(--label); 
        padding: 10px 15px; 
        border: none;
        outline: none; 
    }


    input[type=search]::-ms-clear { display: none; width : 0; height: 0; }
    input[type=search]::-ms-reveal { display: none; width : 0; height: 0; }
    /* clears the ‘X’ from Chrome */
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration { display: none; }
</style>